export enum SystemStateMessageTypes {
  ERRROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  INFO = 'INFO'
}



// WEBPACK FOOTER //
// ./src/models/SystemStateMessageTypes.ts